import logger from "@next/core-logger"
import {AxiosRequestConfig} from "axios"
import {IncomingHttpHeaders} from "http"
import axios from "../../utils/axios"
import ProductsApi from "../../config/api/products"
import {SearchApiRequestTypes, TOKEN_CANCELLATION_FLAG} from "../../config/constants"
import {ExternalSearchApiResponse} from "../../models/searchApi"
import {BloomreachCookiesInitialVal} from "../../models/SearchState"
import {httpUrlTrimmer, urlSanitiser} from "../../utils/httpUrlTrimmer"
import {devboxUrlTrimmer} from "../../utils/devboxUrlTrimmer"
import buildProductsRequestParams from "../../utils/buildProductsRequestParams"

interface GetProductsFragmentFnOptions {
    headers: IncomingHttpHeaders
    url: string
    baseUrl: string
    searchTerm: string | null
    type: SearchApiRequestTypes
    start: number
    pageSize: number
    fields: (keyof ExternalSearchApiResponse)[]
    bloomreachCookiesInitialVal: BloomreachCookiesInitialVal
    bloomreachPersonalizationEnabled: boolean
    cancelToken?: AxiosRequestConfig["cancelToken"]
    pageLoadTrigger: "NEXT" | "PREVIOUS" | "FILTER"
    sliceSize: number
    productSummaryTemplateName?: string
    imageRatio?: string
    bloomreachDefaultProviderArgs: string
}

export const getProductsFragment = async ({
    url,
    baseUrl,
    headers,
    searchTerm,
    type,
    start,
    pageSize,
    fields,
    bloomreachCookiesInitialVal,
    bloomreachPersonalizationEnabled,
    cancelToken,
    pageLoadTrigger,
    sliceSize,
    productSummaryTemplateName,
    imageRatio,
    bloomreachDefaultProviderArgs,
}: GetProductsFragmentFnOptions): Promise<string> => {
    try {
        const getProductsFragmentApi = ProductsApi("getProductsFragment")

        const urlParam = devboxUrlTrimmer(httpUrlTrimmer(url))

        const response = await axios({
            method: getProductsFragmentApi.method,
            url: `${urlSanitiser(baseUrl)}${getProductsFragmentApi.localEndpoint()}`,
            headers: headers as {
                [header: string]: string
            },
            params: buildProductsRequestParams({
                url: urlParam,
                searchTerm,
                type,
                start,
                pageSize,
                bloomreachCookiesInitialVal,
                bloomreachPersonalizationEnabled,
                fields,
                pageLoadTrigger,
                sliceSize,
                productSummaryTemplateName,
                imageRatio,
                bloomreachDefaultProviderArgs,
            }),
            cancelToken,
        })
        return response.data as string
    } catch (error) {
        const err = error as Error

        if (err.message !== TOKEN_CANCELLATION_FLAG) {
            logger.error(error, "getProductFragments")
        }

        throw error
    }
}
